



























// @ts-ignore
import Tools from "../../../helpers/Tools";
import {Component, Vue} from "vue-property-decorator";
import MessageHelper from "../../../helpers/MessageHelper";
import {CurrentGame, GameSettings} from "../../../../types";
// @ts-ignore
import store from "../../../store"
import EventApi from "../../../api/EventsApi";
import {LayoutTypes} from "../../../../enums/layout-types/LayoutTypes";

@Component({
    props: {
        points: {
            required: true,
            type: Number
        }
    },
})

export default class PlayerPoints extends Vue{
    private points!: number;
    private pointsNumber: number = this.points;
    private showChangeCounter: boolean = false;
    private changeCounter: number = 0;
    private changingTimeoutId: number|null = null;


    mounted() {
        this.bindEvents();
    }

    beforeDestroy() {
        this.unbindEvents();
    }

    /**
     * Текущая игра
     */
    private get currentActivity(): CurrentGame|null
    {
        return store.getters.getCurrentActivity;
    }

    /**
     * Настройки текущей игры
     */
    private get currentActivitySettings(): GameSettings|null
    {
        if (!this.currentActivity) {
            return null;
        }
        return this.currentActivity.settings;
    }

    /**
     * Видны ли очки игроков
     */
    private get playerPointsAreVisible(): boolean
    {
        if (!this.currentActivitySettings) {
            return true;
        }
        return this.currentActivitySettings.canViewPlayerPoints;
    }

    /**
     * Можно ли управлять очками игроков
     */
    private get playerPointsAreManageable(): boolean
    {
        if (!this.currentActivitySettings) {
            return true;
        }
        return this.currentActivitySettings.canManagePlayerPoints;
    }

    private get addedPoints()
    {
        const sign = this.changeCounter > 0 ? '+' : '-';
        return sign + Math.abs(this.changeCounter);
    }

    /**
     * Тип лейаута
     * @private
     */
    private get layoutType(): string
    {
        return store.getters.getCurrentLayoutType;
    }

    /**
     * Установить размер шрифта
     * @param points
     * @private
     */
    private pointsFontSize(points: number)
    {
        if (this.layoutType === LayoutTypes.LAYOUT_TASK) {
            if (window.innerWidth >= 1200) {
                return points >= 100 || points < -9 ? '10px' : '12px';
            }
            if (window.innerWidth >= 1900) {
                return points >= 100 || points < -9 ? '14px' : '16px';
            }
        }

        if (window.innerWidth >= 1200 && window.innerWidth < 3800) {
            return points >= 100 || points < 0 ? '16px' : '24px';
        }
        if (window.innerWidth >= 3800) {
            return points >= 100 || points < -9 ? '28px' : '36px';
        }

        return points >= 100 || points < 0 ? '16px' : '24px';
    }

    /**
     * Привязать события
     */
    bindEvents()
    {
        EventApi.addEventListener('keypress', this.onHotKeys);
    }

    /**
     * Отвязать события
     */
    unbindEvents()
    {
        EventApi.removeEventListener('keypress', this.onHotKeys);
    }

    /**
     * Изменить очки
     */
    changePoints(diff: number) {
        this.pointsNumber = this.pointsNumber + diff;
        this.changeCounter = this.changeCounter + diff;
        this.showChangeCounter = true;
        this.$emit('changePoints', this.pointsNumber);
        diff > 0 ? MessageHelper.sendPlaySoundMessage('counterUp') : MessageHelper.sendPlaySoundMessage('counterDown');
    }

    /**
     * Начать изменение очков по интервалу
     */
    changePointsStart(diff: number)
    {
        this.changePointsEnd();
        this.startChangeTimeout(diff, 550);
    }

    /**
     * Начинает таймаут
     */
    startChangeTimeout(diff: number, timeout: number)
    {
        this.changingTimeoutId = window.setTimeout(() => {
            this.changePoints(diff);

            let minTimeout = 50;
            let nextTimeout = timeout - 100;
            if (nextTimeout < minTimeout) {
                nextTimeout = minTimeout;
            }

            this.startChangeTimeout(diff, nextTimeout);
        }, timeout);
    }

    /**
     * Закончить изменение очков по интервалу
     */
    changePointsEnd()
    {
        if (!this.changingTimeoutId) {
            return;
        }
        clearTimeout(this.changingTimeoutId);
    }

    /**
     * Обработка хоткеев
     */
    onHotKeys(e: any)
    {
        const plusButtons = ['Equal', 'NumpadAdd'];
        if (plusButtons.indexOf(e.code) !== -1) {
            const focused = Tools.userFocusedOnInput();
            if (!focused) {
                const isShift = !!e.shiftKey;
                this.changePoints(isShift ? 10 : 1);
            }
        }

        const minusButtons = ['Minus', 'NumpadSubtract'];
        if (minusButtons.indexOf(e.code) !== -1) {
            const focused = Tools.userFocusedOnInput();
            if (!focused) {
                const isShift = !!e.shiftKey;
                this.changePoints(isShift ? -10 : -1);
            }
        }
    }
}
